import { render, staticRenderFns } from "./DateCom.vue?vue&type=template&id=3fc3dea4&scoped=true"
import script from "./DateCom.vue?vue&type=script&lang=js"
export * from "./DateCom.vue?vue&type=script&lang=js"
import style0 from "./DateCom.vue?vue&type=style&index=0&id=3fc3dea4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc3dea4",
  null
  
)

export default component.exports